var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoardIcoImg16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0V13L4 16V13H1V0H15ZM2 12H4V3L11.333 1H2V12Z",
    fill: "#189DC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6003 6.75975C8.75758 6.71212 8.90188 6.77649 8.98434 6.92586L10.1356 9.04935L10.6302 7.96869C10.7146 7.78557 10.8522 7.65102 11.0003 7.60601C11.1483 7.56112 11.2852 7.61264 11.3695 7.74444L12.4197 9.3945C12.5151 9.54509 12.5261 9.77774 12.4494 9.99528C12.3725 10.2131 12.2165 10.3838 12.0496 10.4346L6.95009 11.984C6.78696 12.0336 6.63522 11.9663 6.55647 11.8032C6.47775 11.6401 6.48169 11.4101 6.56605 11.2024L8.2154 7.1575C8.2979 6.9577 8.4428 6.80576 8.6003 6.7579V6.75975ZM11.3425 4.03548C11.8157 3.89171 12.2001 4.19782 12.2003 4.71932C12.2003 5.24104 11.8158 5.78168 11.3425 5.92549C10.8695 6.06907 10.4857 5.76229 10.4856 5.24073C10.4856 4.71912 10.8694 4.17942 11.3425 4.03548Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardIcoImg16);
export default __webpack_public_path__ + "static/media/Board_ico_img_16.b2ca27d0cda246a75635405b5b4a4e15.svg";
export { ForwardRef as ReactComponent };